import React from "react";

export const UiQuestionWrapper = (props) => {
    return (
        <>
            <div className={props.className}>
                <div className="row sb-question-wrapper">
                    {props.children}
                </div>
            </div>
        </>
    )
}